<template>
	<div id="about-us-page" data-aos="fade">
		<!-- Hero -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto text-center">
						<img
							src="public/images/pages/about-us/nosotros.png"
							alt=""
							class="hero-image"
							data-aos="fade-up"
						>
						<h1 class="hero-title" data-aos="fade-up" data-aos-delay="100">Abogados hartos del sistema tradicional</h1>
						<p class="hero-lead" data-aos="fade-up" data-aos-delay="200">
							Conoce al equipo rebelde que está revolucionando la industria legal mexicana
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Manifesto -->
		<section class="manifesto-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-8 mx-auto text-center">
						<p class="manifesto-text" data-aos="fade-up">
							Nos mueve profundamente ofrecer una conexión genuina y humana entre quienes buscan ayuda y quienes pueden
							brindarla, porque sabemos que cuando te enfrentas a problemas legales es común sentirte paralizado y tomar
							decisiones erróneas.
						</p>
						<p class="manifesto-text" data-aos="fade-up" data-aos-delay="100">
							No solo desbloqueamos soluciones, también creamos relaciones que trascienden un trámite. Conectamos
							personas, negocios y oportunidades, formando una comunidad donde la colaboración genera movimiento y todo
							comienza a fluir.
						</p>
						<p class="manifesto-highlight" data-aos="fade-up" data-aos-delay="200">
							Porque cuando lo legal se desbloquea, los caminos se abren.
						</p>
						<p class="manifesto-tagline" data-aos="fade-up" data-aos-delay="300">
							En UNLAWK, you're in control. Legally.
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- Contenido principal -->
		<section class="content-section">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-md-6 mb-4 mb-md-0">
						<div class="info-card info-card--navy mb-4" data-aos="fade-left">
							<h3 class="info-card-title">¿Quiénes somos?</h3>
							<p class="info-card-text info-card-text--light">
								Somos un grupo de abogados experimentados y especializados que estamos completamente hartos del
								sistema legal tradicional. Cansados de los procesos lentos, la falta de transparencia y la desconexión
								entre abogados y clientes.
							</p>
						</div>

						<div class="info-card info-card--primary mb-4" data-aos="fade-left" data-aos-delay="100">
							<h3 class="info-card-title">¿Por qué UNLAWK?</h3>
							<p class="info-card-text info-card-text--light">
								Decidimos crear UNLAWK porque creemos que el derecho debe ser accesible, rápido y transparente. No
								más esperas eternas, no más procesos burocráticos innecesarios, no más cobros ocultos.
							</p>
						</div>

						<div class="info-card info-card--mint" data-aos="fade-left" data-aos-delay="200">
							<h3 class="info-card-title info-card-title--dark">Nuestra misión</h3>
							<p class="info-card-text">
								Revolucionar la industria legal mexicana conectando directamente a las personas con abogados
								especializados, eliminando intermediarios y reduciendo tiempos de respuesta de semanas a días.
							</p>
						</div>
					</div>

					<div class="col-md-6">
						<div class="stat-card stat-card--navy mb-4" data-aos="fade-right">
							<div class="stat-icon">
								<i class="fa-regular fa-users"></i>
							</div>
							<h3 class="stat-value">+50</h3>
							<p class="stat-label">Abogados rebeldes unidos</p>
						</div>

						<div class="stat-card stat-card--primary mb-4" data-aos="fade-right" data-aos-delay="200">
							<div class="stat-icon">
								<i class="fa-regular fa-messages"></i>
							</div>
							<h3 class="stat-value">1,000+</h3>
							<p class="stat-label">Casos resueltos más rápido</p>
						</div>

						<div class="stat-card stat-card--mint" data-aos="fade-right" data-aos-delay="350">
							<div class="stat-icon stat-icon--dark">
								<i class="fa-regular fa-arrow-right"></i>
							</div>
							<h3 class="stat-value stat-value--dark">90%</h3>
							<p class="stat-label stat-label--dark">Reducción en tiempos</p>
						</div>
					</div>
				</div>

				<!-- CTA -->
				<div class="row mt-5">
					<div class="col-12 col-lg-10 mx-auto" data-aos="fade-up">
						<div class="join-cta text-center">
							<h3 class="join-cta-title">¿Te unes a la revolución legal?</h3>
							<p class="join-cta-lead">
								Si eres abogado y también estás harto del sistema tradicional, únete a nosotros. Si eres cliente y
								necesitas asesoría legal rápida y transparente, estamos aquí para ti.
							</p>
							<div class="d-flex flex-column flex-sm-row justify-content-center join-cta-actions">
								<b-button
									to="/afiliacion"
									variant="light"
									size="lg"
									class="join-btn join-btn--solid mb-2 mb-sm-0 mr-sm-3"
								>
									Soy abogado, quiero unirme
								</b-button>
								<b-button
									to="/chat"
									variant="outline-light"
									size="lg"
									class="join-btn join-btn--outline"
								>
									Necesito asesoría legal
								</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Botón flotante Lexi -->
		<div class="lexi-float">
			<b-button to="/chat" size="lg" class="lexi-float-btn">
				<i class="fa-regular fa-robot mr-2"></i>
				<span>Platica con Lexi</span>
			</b-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
}
</script>
